"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const fragments_1 = require("../fragments");
const HomePageContentQuery = (0, graphql_tag_1.default) `
  query homePageContent(
    $site: String
    $includeMeta: Boolean = false
    $includePopularDepartments: Boolean = false
    $includeHotlinks: Boolean = false
    $includeNewsletter: Boolean = false
    $includeLinkList: Boolean = false
  ) {
    homePageContent(storeId: $site) {
      storeId
      h1
      meta @include(if: $includeMeta) {
        ...meta
      }
      popularDepartments @include(if: $includePopularDepartments) {
        ...item
      }
      hotLinks @include(if: $includeHotlinks) {
        ...item
      }
      newsletter @include(if: $includeNewsletter) {
        ...newsletter
      }
      linkList @include(if: $includeLinkList) {
        ...linkList
      }
    }
  }
  ${fragments_1.SeoMetaFragment}
  ${fragments_1.HotLinksItemFragment}
  ${fragments_1.NewsletterFragment}
  ${fragments_1.BlogLinkListFragment}
`;
exports.default = HomePageContentQuery;
